import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c2c9176c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c2c9176c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c9176c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/matin/baarbaanet/frontend/panel/driver/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2c9176c')) {
      api.createRecord('c2c9176c', component.options)
    } else {
      api.reload('c2c9176c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c2c9176c&scoped=true&", function () {
      api.rerender('c2c9176c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/brb-components/brb-image-preview/index.vue"
export default component.exports